import React, { useState, useEffect } from "react";
import TeacherPanel from "../panel/TeacherPanel";
import api from "../../../api/api";
import "../styles/TeacherHomeworkPage.css";

const TeacherHomeworkPage = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [classes, setClasses] = useState([]);
  const [sections, setSections] = useState([]);
  const [classId, setClassId] = useState("");
  const [sectionId, setSectionId] = useState("");
  const [subject, setSubject] = useState("");
  const [topic, setTopic] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [questions, setQuestions] = useState([""]);
  const [comment, setComment] = useState("");
  const [color, setColor] = useState("#00bfff");

  useEffect(() => {
    fetchClasses();
  }, []);

  // Fetch all classes assigned
  const fetchClasses = async () => {
    try {
      const res = await api.get("/api/classes");
      setClasses(res.data);
    } catch (err) {
      console.error("Failed to fetch classes:", err);
    }
  };

  // Fetch sections for selected class
  const fetchSections = async (classId) => {
    if (!classId) return;
    try {
     const res = await api.get("/api/sections", {
  params: { classId }
});
      setSections(res.data);
      setSectionId(""); // reset section
      setSubject("");   // reset subject when class changes
    } catch (err) {
      console.error("Failed to fetch sections:", err);
    }
  };
useEffect(() => {
  if (classId) {
    fetchSections(classId);
  }
}, [classId]);

useEffect(() => {
  if (classId && sectionId) {
    fetchTeacherSubject(classId, sectionId);
  }
}, [classId, sectionId]);
  // Fetch teacher's assigned subject for selected class + section
  const fetchTeacherSubject = async (classId, sectionId) => {
    if (!classId || !sectionId) return setSubject("");
    try {
      const res = await api.get("/api/homework/teacher-subjects", {
  params: { classId, sectionId }
});
      setSubject(res.data?.[0] || ""); // assume first subject assigned
    } catch (err) {
      console.error("Failed to fetch teacher subject:", err);
      setSubject("");
    }
  };

  const handleQuestionChange = (idx, value) => {
    const arr = [...questions];
    arr[idx] = value;
    setQuestions(arr);
  };

  const addQuestion = () => setQuestions([...questions, ""]);

  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!classId || !sectionId || !subject || !topic || !dueDate) {
    alert("Please fill all required fields");
    return;
  }

  try {
    const res = await api.post("/api/homework", {
      classId,
      sectionId,
      subject,
      topic,
      dueDate,
      questions: questions.filter(q => q.trim() !== ""),
      comment,
      color
    });

    alert(res.data.message);

    setClassId("");
    setSectionId("");
    setSubject("");
    setTopic("");
    setDueDate("");
    setQuestions([""]);
    setComment("");
    setColor("#00bfff");
    setSections([]);

  } catch (err) {
    console.error("Homework creation failed:", err.response || err);
    alert(err.response?.data?.error || "Failed to create homework");
  }
};

  return (
    <>
      <TeacherPanel onToggle={setIsSidebarCollapsed} />
      <div className={`hw-main-container ${isSidebarCollapsed ? "collapsed" : ""}`}>
        <h2>Create Homework</h2>
        <form onSubmit={handleSubmit} className="hw-form">

          {/* Class Selection */}
          <label>Class:</label>
          <select
            value={classId}
            onChange={e => {
              const selectedClass = e.target.value;
              setClassId(selectedClass);
              fetchSections(selectedClass);
            }}
            required
          >
            <option value="">-- Select Class --</option>
            {classes.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>

          {/* Section Selection */}
          <label>Section:</label>
          <select
            value={sectionId}
            onChange={e => {
              const selectedSection = e.target.value;
              setSectionId(selectedSection);
              fetchTeacherSubject(classId, selectedSection);
            }}
            required
          >
            <option value="">-- Select Section --</option>
            {sections.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
          </select>

          {/* Subject (readonly) */}
          <label>Subject:</label>
          <input
            value={subject || ""}
            readOnly
            placeholder="Assigned subject"
          />

          {/* Topic */}
          <label>Topic:</label>
          <input
            value={topic}
            onChange={e => setTopic(e.target.value)}
            required
          />

          {/* Due Date */}
          <label>Due Date:</label>
          <input
            type="date"
            value={dueDate}
            onChange={e => setDueDate(e.target.value)}
            required
          />

          {/* Questions */}
          <label>Questions:</label>
          {questions.map((q, idx) => (
            <input
              key={idx}
              value={q}
              onChange={e => handleQuestionChange(idx, e.target.value)}
              required
            />
          ))}
          <button type="button" onClick={addQuestion}>+ Add Question</button>

          {/* Comment */}
          <label>Comment:</label>
          <textarea
            value={comment}
            onChange={e => setComment(e.target.value)}
          />

          {/* Card Color */}
          <label>Card Color:</label>
          <input
            type="color"
            value={color}
            onChange={e => setColor(e.target.value)}
          />

          <button type="submit">Save Homework</button>
        </form>
      </div>
    </>
  );
};

export default TeacherHomeworkPage;
